var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"big"},[_c('sidebar'),_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"content-inner"},[_c('router-view')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }